// npm packages
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// project imports
import { CustomAccordion } from "./Accordion/CustomAccordion";
import { FloatingBox } from "./FloatingBox";

import "./Experience.css";

export const Experience = () => {
  const { t } = useTranslation();

  return (
    <section className="experience" id="experience">
      <Container className="experience__floatingBox-container">
        <Col sm={12}>
          <FloatingBox />
        </Col>
      </Container>

      <Container>
        <Row className="experience__body align-items-center justify-content-center">
          <Col sm={12}>
            <div className={"animate__animated animate__fadeIn"}>
              <h2>{t("experience.title")}</h2>
              <h3>{t("experience.subtitle")}</h3>
            </div>
          </Col>

          <Col sm={9} className="mt-2">
            <CustomAccordion />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
